import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableVirtuoso } from "react-virtuoso";
// import ResizeObserver from "resize-observer-polyfill";
import http from "services/httpService";
import {
  BoxHeading,
  ContentRow,
  HeaderRow,
  InputDiv,
  MaterialTable,
  MaterialTableContainer,
  Option,
  SearchfilterDiv,
  TableWrapper,
  Download,
} from "./styles";
import { Chip, Icons, LoaderDots, Ptag } from "components/core";
import DownloadIcon from "assets/images/downloadcsv.png";
import AddIcon from "assets/svgs/add.svg";
import { useNavigate } from "react-router";
import { DownloadLink } from "pages/CareDashboard/styles";
import { capitalizeSecondLetter, formatToRupees } from "utlis/utils";
import "./styles.css";
import { MessageDiv } from "pages/CareDashboard/CareDashboardList";
import Lottie from "react-lottie";
import emptyFile from "assets/lottie/empty_file.json";
import { FlexColumn } from "../Cards/styles";

const ReactVirtualizedTable = ({ companyData, showTable }) => {
  const userplanIds = JSON.parse(localStorage.getItem("flex_userplan_ids"));
  const timerRef = useRef(null);
  const [currentEmployees, setCurrentEmployee] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [overallData, setOverallData] = useState();
  const [currentProduct, setCurrentProduct] = useState(
    JSON.parse(localStorage.getItem("flex_products_list"))[0]
  );
  const [searchString, setSearchString] = useState("");

  const [columns, setColumns] = useState([]);

  const [currentlySelectedFilter, setCurrentlySelectedFilter] = useState();

  const handleStatusCheckbox = async (e, status) => {
    const isChecked = e.target.checked;
    const userplanId = userplanIds[currentProduct];
    setOverallData([]);
    if (isChecked) {
      setCurrentlySelectedFilter({ ...status, userplanId });
      await getModernFlex(null, { ...status, userplanId });
    } else {
      setCurrentlySelectedFilter(null);
      await getModernFlex();
    }
  };

  function fixedHeaderContent() {
    return (
      <TableRow>
        {columns.map((column, index) => (
          <TableCell
            key={index}
            variant="head"
            align="center"
            style={{ width: column.width }}
            sx={HeaderRow}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
  }

  const navigate = useNavigate();
  useEffect(() => {
    getModernFlex();
  }, []);

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  const VirtuosoTableComponents = {
    Scroller: forwardRef((props, ref) => (
      <TableContainer {...props} ref={ref} sx={MaterialTableContainer} />
    )),
    Table: (props) => <Table {...props} sx={MaterialTableNew} />,
    TableHead,
    TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
    TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  };

  function isActivatedFlexEmployee(status) {
    const show = status.join().includes("ACTIVATED");
    return show;
  }
  const getFlexProductStatus = (status) => {
    let JSX = [];
    status.forEach((value, index) => {
      if (value.includes("PENDING")) {
        JSX.push(
          <Chip
            background="#F7CB59"
            text={capitalizeSecondLetter(value)}
            className="child-component"
          />
        );
      } else if (value.includes("ACTIVATED")) {
        JSX.push(
          <Chip
            background="#81C14B"
            text={capitalizeSecondLetter(value)}
            className="child-component"
          />
        );
      } else if (value.includes("DELET")) {
        JSX.push(
          <Chip
            background="#FF9446"
            text={capitalizeSecondLetter(value)}
            className="child-component"
          />
        );
      } else if (value.includes("STOPPED")) {
        JSX.push(
          <Chip
            background="#F27576"
            text={capitalizeSecondLetter(value)}
            className="child-component"
          />
        );
      }
    });

    return (
      <section
        style={{ gap: "0.6rem", display: "flex", justifyContent: "center" }}
      >
        {JSX.map((el) => el)}
      </section>
    );
  };

  function jsxRow(column, index, row) {
    let JSX;
    const columnWidth = column.width + "px";
    switch (column.label) {
      case "E-Card":
        JSX = (
          <TableCell
            align="center"
            style={{
              width: columnWidth,
            }}
            sx={ContentRow}
            key={index}
            f
          >
            {isActivatedFlexEmployee(row.Status) ? (
              <DownloadLink onClick={() => navigateToEcardPreview(row)}>
                View
              </DownloadLink>
            ) : (
              <Ptag
                textAlign="center"
                fontSize="14px"
                lineHeight={1.3}
                fontWeight="500"
              >
                -
              </Ptag>
            )}
          </TableCell>
        );
        break;
      case "Status":
        JSX = (
          <TableCell sx={ContentRow}>
            {getFlexProductStatus(row.Status)}
          </TableCell>
        );
        break;
      default: {
        const targetLabel = "Sum Insured";
        const isSumInsuredColumn = column.label.includes(targetLabel);

        let formattedValue;

        if (isSumInsuredColumn) {
          const cellValue = row[column.label]
            ? row[column.label].toString()
            : "";

          if (cellValue) {
            formattedValue = formatToRupees(cellValue);
          } else {
            formattedValue = "-";
          }
        } else {
          formattedValue = row[column.label] || "-";
        }
        JSX = (
          <TableCell align="center" sx={ContentRow} key={index}>
            {formattedValue || "_"}
          </TableCell>
        );
        break;
      }
    }
    return JSX;
  }

  function rowContent(_index, row) {
    let JSX;
    try {
      JSX = <>{columns.map((column, index) => jsxRow(column, index, row))}</>;
    } catch (error) {}
    return JSX;
  }

  const navigateToEcardPreview = (row) => {
    navigate("/e-card-preview", {
      state: {
        employeeId: row["System Employee Id"],
        productType: currentProduct,
      },
    });
  };
  const getModernFlex = async (searchString, isFilter) => {
    let localToken = -1;
    let error = false;
    while (localToken !== 0 && localToken !== null && error === false) {
      const payload = {
        token: localToken,
        offset: 1000,
        // mis_flag: true,
      };
      if (searchString) payload.search_string = searchString;
      if (isFilter) {
        payload.status_filter = isFilter.display_policy_status;
        payload.status_filter_userplan_id = isFilter.userplanId;
      }
      try {
        let { data } = await http.get(
          "business/get_employee_detail_for_group_products/",
          {
            params: payload,
          }
        );
        if (data?.mis_employee_data) {
          setOverallData((prevData) => {
            if (!prevData) {
              return data.mis_employee_data; // Assign new data directly if prevData is empty
            }
            // Merge previous data with new data
            return [...prevData, ...data.mis_employee_data];
          });
        } else {
          setOverallData([]);
        }

        if (localToken == -1) {
          const status_width = (data.headers_data.length - 4) / 2;
          const col_name = data.headers_data;
          const newColm = col_name.map((val, index) => {
            let local_width = 150;
            if (val == "Status") {
              local_width = status_width * 150;
            }
            return { width: local_width, label: val };
          });
          setColumns(newColm);
        }
        localToken = data.end_index;
        // setOverallData((prevArray) => [...prevArray, data.mis_employee_data]);
      } catch (e) {
        error = true;
        console.log(e);
      } finally {
        if (!searchString && !isFilter) setIsLoading(false);
      }
    }
  };
  const navigeteToAddDeletPage = () => {
    const flex_userplan_ids = Object.keys(companyData).reduce((acc, key) => {
      acc[key] = companyData[key].userplan;
      return acc;
    }, {});
    localStorage.setItem(
      "flex_userplan_ids",
      JSON.stringify(flex_userplan_ids)
    );
    sessionStorage.setItem("flex_setup_type", "add_delete");
    navigate("/flex/setup/master", { state: { flow: "add_delete" } });
  };

  const downloadExcel = async () => {
    let { data } = await http.post(
      "business/download_mis_or_data_collection/",
      {},
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };

  const shouldShowHalf = () => {
    const totalEmp = currentEmployees && currentEmployees.length;
    if (totalEmp > 4) {
      return false;
    }
    return true;
  };

  const handleSearchChange = (e) => {
    const newSearchString = e.target.value;
    setSearchString(newSearchString);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Set a new timer to call the API after 2 seconds
    timerRef.current = setTimeout(async () => {
      setOverallData([]);
      await getModernFlex(newSearchString);
    }, 500);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: emptyFile,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: "44px" }}
        >
          <LoaderDots />
        </div>
      ) : (
        <>
          <BoxHeading style={{ alignItems: "flex-start" }}>
            <Ptag fontSize="24px" fontWeight="700" marginTop="4px">
              Manage Employees
            </Ptag>
            {showTable && (
              <Download onClick={downloadExcel}>
                <img
                  src={DownloadIcon}
                  width="18px"
                  height="18px"
                  style={{ marginRight: 8 }}
                />
                <Ptag
                  fontSize="14px"
                  fontWeight="600"
                  color="#FFFFFF"
                  lineHeight="24px"
                  letterSpacing="0.5px"
                >
                  Download Employee Data
                </Ptag>
              </Download>
            )}
          </BoxHeading>
          {showTable ? (
            <>
              <SearchfilterDiv>
                <InputDiv style={{ maxWidth: "60%" }}>
                  <input
                    value={searchString}
                    onChange={handleSearchChange}
                    className="input-elevated"
                    type="text"
                    placeholder="Search with Employee ID or Name"
                  />
                </InputDiv>
                <div style={{ display: "flex" }}>
                  {/* <FilterDiv>
                <FilterImage src={FilterIcon} />
                <Dropdown color="#fff">
                  <Option value="" default disabled selected hidden>
                    Filter
                  </Option>
                  <Option value={"none"}>{"None"}</Option>
                </Dropdown>
                <div style={{ marginRight: "12px" }}>
                  <Icons icon={"chevron_down"} fill="#ffffff" />
                </div>
              </FilterDiv> */}
                </div>
              </SearchfilterDiv>
              <TableWrapper showHalf={shouldShowHalf()}>
                <TableVirtuoso
                  data={overallData}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </TableWrapper>
            </>
          ) : (
            <MessageDiv>
              <FlexColumn>
                <Lottie
                  options={defaultOptions}
                  height={120}
                  width={120}
                  style={{ opacity: "1" }}
                  isClickToPauseDisabled
                />
                <Ptag fontSize="18px" fontWeight="600" lineHeight="20">
                  Employee Data Unavailable
                </Ptag>
              </FlexColumn>
            </MessageDiv>
          )}
        </>
      )}
    </>
  );
};

export default ReactVirtualizedTable;

export const MaterialTableNew = {
  tableLayout: "fixed",
  border: "none",
  borderCollapse: "separate",
  "*": {
    fontSize: "14px !important",
  },
};
